import $ from 'jquery'
import ClipboardJS from 'clipboard'

const copy = new ClipboardJS('.copy-button')
let timeOut

copy.on('success', function (e) {
  if (timeOut) {
    clearTimeout(timeOut)
  }

  const icon = $(e.trigger).find('i')

  icon.removeClass('vn-icons-copy')
  icon.addClass('vn-icons-check')

  timeOut = setTimeout(() => {
    icon.addClass('vn-icons-copy')
    icon.removeClass('vn-icons-check')
  }, 3000)
})
